<template>
    <div v-if="matchingList" class="matchingSuccess_box">
        <div class="matchingSuccess_box_content">
            <div class="child_box">
                <div class="child_box_title">您的预估贷款额度已超过 <span>{{matchingList.percentInt}}%</span> 的用户！</div>
                <img src="../../../static/image/matching/h5box.png" alt="" width="100%">
                <div class="content_txt">
                    <div class="txt1">预估最高贷款额度</div>
                    <div class="txt2"><span>{{matchingList.estimatedMaximumAmount | estimatedMaximumAmount}}</span>元</div>
                    <div class="txt3">最合适的贷款产品 <span>{{matchingList.result.length}}</span> 个</div>
                </div>
                <img class="img1" src="../../../static/image/matching/h5light.png" alt="" width="100%">
                <img class="img_gif" @click="handleLoan" src="../../../static/image/matching/h5btn.gif" alt="" width="180px">
                <van-icon @click="handleClose" class="icon_1" name="close" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'matchingSuccess',
    props:['matchingList'],
    data() {
        return {

        }
    },

    filters:{
        estimatedMaximumAmount(v) {
            return (v*10000+'').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
        }
    },

    methods:{
        // 马上贷款
        handleLoan() {
            this.$emit('handleLoan')
        },

        // 关闭
        handleClose() {
            this.$emit('handleClose')
        }
    }
}
</script>

<style lang="less" scoped>
.matchingSuccess_box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 999;
    .matchingSuccess_box_content {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        .child_box {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 560px;
            width: 375px;
            padding: 15px;
            position: relative;
            .child_box_title {
                font-size: 16px;
                font-weight: bold;
                background-image: linear-gradient(135deg,#FFD98F,#FFFBE8);
                background-clip:text;
                -webkit-background-clip:text;
                color: transparent;
                margin-bottom: 30px;
                span {
                    font-family: DIN;
                    font-size: 32px;
                }
            }
            .img1 {
                position: absolute;
                top: -60px;
                z-index: -1;
            }
            .content_txt {
                position: absolute;
                width: 100%;
                text-align: center;
                color: #444444;
                font-size: 18px;
                padding-top: 45px;
                .txt1 {
                    margin-bottom: 10px;
                }
                .txt2 {
                    margin-bottom: 10px;
                    background: linear-gradient(180deg, #FFBF6B 0%, #FF7901 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    font-size: 20px;
                    span {
                        font-family: DIN;
                        font-size: 40px;
                    }
                }
                .txt3 {
                    span {
                        background: linear-gradient(180deg, #FFBF6B 0%, #FF7901 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        font-size: 22px;
                        font-weight: 600;
                    }
                }
            }
            .img_gif {
                position: absolute;
                bottom: 112px;
            }
            .icon_1 {
                font-size: 40px;
                //  position: absolute;
                color: #999999;
                margin-top: 75px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/modules/matchingSuccess/index.vue